import { IFind } from '../create-report/interfaces';

export function mergeFilters({ serverFiltersString, userFiltersString }: {
  serverFiltersString: string;
  userFiltersString: string;
}): string {
  const serverFiltersObject = serverFiltersString?.length ? JSON.parse(serverFiltersString) : null;
  const userFiltersObject = userFiltersString?.length ? JSON.parse(userFiltersString) : null;

  let serverFilters: IFind[];
  if (serverFiltersObject?.$and) {
    serverFilters = serverFiltersObject.$and;
  } else if (serverFiltersObject) {
    serverFilters = [serverFiltersObject];
  } else {
    serverFilters = [];
  }

  let userFilters: IFind[];
  if (userFiltersObject?.$and) {
    userFilters = userFiltersObject.$and;
  } else if (userFiltersObject) {
    userFilters = [userFiltersObject];
  } else {
    userFilters = [];
  }

  const mergedConditions = serverFilters.concat(userFilters);

  if (mergedConditions.length === 0) {
    return '';
  } if (mergedConditions.length === 1) {
    return JSON.stringify(mergedConditions[0]);
  }
  return JSON.stringify({ $and: mergedConditions });
}

export function mergeQueryParamFilters(
  persistedFindString: string,
  queryFindString: string,
): string {
  if (!queryFindString?.length) {
    return persistedFindString || '';
  }

  const toConditions = (findString: string): IFind[] => {
    if (!findString?.length) return [];
    const parsed = JSON.parse(findString);
    if (parsed?.$and) return parsed.$and as IFind[];
    return Object.keys(parsed).map((key) => ({ [key]: parsed[key] }) as IFind);
  };

  const fieldOf = (condition: IFind): string => Object.keys(condition)[0]?.toLowerCase();

  const queryConditions = toConditions(queryFindString);
  const overriddenFields = new Set(queryConditions.map(fieldOf));

  const preservedConditions = toConditions(persistedFindString)
    .filter((condition) => !overriddenFields.has(fieldOf(condition)));

  const mergedConditions = preservedConditions.concat(queryConditions);

  if (mergedConditions.length === 0) {
    return '';
  } if (mergedConditions.length === 1) {
    return JSON.stringify(mergedConditions[0]);
  }
  return JSON.stringify({ $and: mergedConditions });
}

export function mergeSorts({ serverSortsString, userSortsString }: {
  serverSortsString: string;
  userSortsString: string;
}): string {
  const serverSortsObject = serverSortsString?.length ? JSON.parse(serverSortsString) : {};
  const userSortsObject = userSortsString?.length ? JSON.parse(userSortsString) : {};

  const mergedSortObject = {
    ...serverSortsObject,
    ...userSortsObject,
  };

  return JSON.stringify(mergedSortObject);
}
